import type {CostRecord, Currency} from '../shared/contracts';

/** Current ledger records linked by the job's saved IDs. Never reads AI prose. */
export function reviewCosts(vehicleId:string, costIds:readonly string[], records:readonly CostRecord[]){
 const ids=[...new Set(costIds)];
 const found=ids.map(id=>records.find(c=>c.id===id&&c.vehicleId===vehicleId));
 const linked=found.filter((c):c is CostRecord=>!!c);
 const groups=new Map<string,{currency:Currency;basis:CostRecord['basis'];direction:CostRecord['direction'];count:number;total:bigint;invalid:boolean}>();
 for(const c of linked){
  if(c.status!=='active')continue;
  const key=[c.currency,c.basis,c.direction].join('/');
  const group=groups.get(key)??{currency:c.currency,basis:c.basis,direction:c.direction,count:0,total:0n,invalid:false};
  group.count++;
  if(Number.isSafeInteger(c.amountMinor)&&c.amountMinor>=0)group.total+=BigInt(c.amountMinor);else group.invalid=true;
  groups.set(key,group);
 }
 return {linked,missing:ids.length-linked.length,voided:linked.filter(c=>c.status==='void').length,
  totals:[...groups.values()].map(({total,invalid,...g})=>({...g,amountMinor:!invalid&&total<=BigInt(Number.MAX_SAFE_INTEGER)?Number(total):null}))};
}
